import {Component, ElementRef, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {PocsagItem} from './pocsag.module';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from '../share/localstorage.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {SyncService} from '../share/sync.service';
import {DataModel} from '../share/data.model';
import {openDB, IDBPTransaction, deleteDB, wrap, unwrap, IDBPDatabase} from 'idb';


@Component({
    selector: 'app-pocsag',
    templateUrl: './pocsag.component.html',
    styleUrls: ['./pocsag.component.css'],
    standalone: false
})
export class PocsagComponent implements OnInit, OnDestroy {
    public Ueberschrift: string = this.ls.get('APP_Ueberschrift');
    public PocsagItems: PocsagItem[] = [];
    public AllPocsagItems: PocsagItem[] = [];
    public letzteAktualisierung = null;
    public neueMeldung = false;
    public schriftgross: boolean = false;

    public filter: string = '';
    public debug_txt: string ='<br><br>Start:<br>';

    public debug: boolean = false;


    private db: IDBPDatabase;


    private subscription: any = null;
    private subscription_letzteaktualisierung: any;
    private alive = true;

    @ViewChild('hash_PocsagItems') private myScrollContainer: ElementRef;

    @ViewChildren('pocsag_items') private slides: QueryList<ElementRef>;

    constructor(private http: HttpClient,
                private router: Router,
                private ls: LocalStorageService,
                private activatedRoute: ActivatedRoute,
                private SyncService: SyncService
    ) {
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        setTimeout(() => {

            this.router.navigate(['/menu']).then(() => {
            });
        }, 5);

    }






    ngOnInit() {
        this.debug_txt += this.timestamp()+'NGOnInit hat gezündet<br>';
        if (this.ls.get('anzeigegroesser') !== 'true') this.schriftgross = false;
        else this.schriftgross = true;
        // Sync starten, falls es ein dirket Aufruf der URL ist
        this.SyncService.sync('');


        this.AllPocsagItems = this.SyncService.getPocsag_zwischenspeicher();
        this.PocsagItems = this.SyncService.getPocsag_zwischenspeicher();
        this.getPocsagData().then(() => {
            this.limitPocsagData();
            if (this.PocsagItems.length == 0) {
                this.PocsagItems.push(new PocsagItem('1','00',['IMMER'],['KEINE DATEN'],['1'],'Bitte oben rechts in die Einstellungen und auswählen, welche Pocsag Meldungen angezeigt werden sollen',''));
            }
        });


        //let PocsagDataString: string = String(localStorage.getItem('PocsagData'));


        //this.PocsagItems = JSON.parse(PocsagDataString);


        // this.limitPocsagData(20);

        this.subscription = this.SyncService.PocsagData
            .subscribe(
                (Data: DataModel) => {
                    this.debug_txt += this.timestamp()+'NeueDaten:<br>';
                    console.log('NEUE DATA');
                    this.getPocsagData().then(()=>{
                        if (this.myScrollContainer.nativeElement.scrollTop > 40 || this.filter.length >= 2) {
                            this.debug_txt += this.timestamp()+'Scroll to neue Meldung<br>';
                            this.neueMeldung = true;
                        }
                        //let PocsagDataString: string = String(localStorage.getItem('PocsagData'));
                        //this.PocsagItems = JSON.parse(PocsagDataString);


                        this.limitPocsagData()
                        this.filterPocsag();
                    });



                }
            )


        this.subscription_letzteaktualisierung = this.SyncService.letzter_Datenaustausch
            .subscribe((time: string) => {
                this.letzteAktualisierung = time;
        });


        // if (this.ls.get('User_Key') === undefined || this.ls.get('User_Key') === 'undefined' || this.ls.get('User_Key') === '' || this.ls.get('User_Key') === null) {
        //    this.router.navigate(['/']).then(function () {
        //   });
        // }
        this.letzteAktualisierung = this.ls.get('Pocsag_letzteAktualisierung');
        //this.PocsagItems = this.ls.get_PocsagItems('Pocsag_PocsagItems');
        //setTimeout(() => {
        //  this.getdata();
        //}, 100);

        setTimeout(() => {
            this.activatedRoute.params.subscribe(
                params => {
                    this.scrollto(params['id']);
                });
        }, 250);
    }


    public filterPocsag() {

        this.PocsagItems = [];
         if (this.filter == '' || this.filter.length <2) {
             this.PocsagItems = this.AllPocsagItems;
         } else {
             for (let i = 0; i < this.AllPocsagItems.length; i++) {
                 if (this.AllPocsagItems[i].nachricht.toLowerCase().includes(this.filter.toLowerCase())) {
                     this.PocsagItems.push(this.AllPocsagItems[i]);
                 } else {
                     for (let j = 0; j < this.AllPocsagItems[i].bezeichnung.length; j++) {
                         if (this.AllPocsagItems[i].bezeichnung[j].toLowerCase().includes(this.filter.toLowerCase())) {
                             this.PocsagItems.push(this.AllPocsagItems[i]);
                         }
                     }
                 }
             }
         }
    }

    async getPocsagData() {

        this.debug_txt += this.timestamp()+'getPocsagData<br>';
        await this.open_db()
            .then(() => {
                let data = this.db.getAll('pocsag');

                this.debug_txt += this.timestamp()+'DB->GetAll<br>';

                return data;
            }).then((data) => {


                this.debug_txt += this.timestamp()+'Leeren<br>';
                this.PocsagItems = [];

                this.AllPocsagItems = [];
                //this.PocsagItems = data;
                let o = 0;
                data.forEach(entry => {
                    o++;
                    this.PocsagItems.unshift(entry);
                    this.AllPocsagItems.unshift(entry);
                });

                this.debug_txt += this.timestamp()+'NeueDaten! '+o+' Mal unschift<br><hr>';
             //   this.SyncService.savePocsag_zwischenspeicher(this.PocsagItems);
            });
    }

    async open_db() {       // Prüft ob die DB vorhanden ist, legt diese sonst an!
        this.db = await openDB('fapp-store', 1, {});
    }


    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = 0;
        } catch (err) {
        }
    }

    onNeueMeldung() {
        this.filter = '';
        this.filterPocsag();
        this.neueMeldung = false;
        this.scrollToBottom();
    }

    ngOnDestroy() {
        this.alive = false;
        this.subscription.unsubscribe();
        this.subscription  = null;
    }

    onSelectItem(id: string) {

            this.router.navigate(['/pocsagdetail', id]).then(() => {
            });

    }


    scrollto(id: string) {
        const dir = this.slides.find(dir => dir.nativeElement.id === 'pocsag_' + id);
        if (dir !== undefined) {
            dir.nativeElement.scrollIntoView({ehavior: 'smooth'});
        }
    }


    limitPocsagData() {
        const limit = 500;
        const toDel = this.AllPocsagItems.length-limit;
        if (toDel > 0) {

            for (let i = toDel; i >=0 ; i--) {
                if (this.AllPocsagItems[this.AllPocsagItems.length-i]) {
                    this.db.delete('pocsag',this.AllPocsagItems[this.AllPocsagItems.length-i].id);
                }
            }
        }


    }


    debugmodetoggle() {
        if (this.debug == true) {
            this.debug = false;
        } else {
            this.debug = true;
        }

    }

    timestamp() {
        const a = new Date();
        return a.getHours()+':'+a.getMinutes()+':'+a.getSeconds()+': ';
    }

}
